module.exports = __webpack_public_path__ + "img/main-01-16-banner.9260ecc0.png";